import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/news/detail/:id',
    name: 'newsDetail',
    component: () => import('@/views/detailPage/news'),
  },
  {
    path: '/affiche/detail/:id',
    name: 'detailPageAffiche',
    component: () => import('@/views/detailPage/affiche/affiche.vue'),
    meta: {
      title: '公告',
    },
  },
  {
    path: '/report/detail/:id',
    name: 'detailPageReport',
    component: () => import('@/views/detailPage/report/report.vue'),
    meta: {
      title: '研报',
    },
  },
  // OEM公版公告
  {
    path: '/afficheList',
    name: 'afficheList',
    component: () => import('@/views/affiche/list'),
  },
  {
    path: '/afficheDetail',
    name: 'afficheDetail',
    component: () => import('@/views/affiche/detail'),
  },
  {
    path: '/moreAffiche',
    name: 'moreAffiche',
    component: () => import('@/views/affiche/more'),
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  next();
});

export default router;
